import { render, staticRenderFns } from "./Deopsit.vue?vue&type=template&id=abf88c30&scoped=true"
import script from "./Deopsit.vue?vue&type=script&lang=js"
export * from "./Deopsit.vue?vue&type=script&lang=js"
import style0 from "./Deopsit.vue?vue&type=style&index=0&id=abf88c30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf88c30",
  null
  
)

export default component.exports